export default __webpack_public_path__ + "4dfb830cbc0b310481d0c05470af6899.svg";